import React, {useMemo, useState} from 'react';
import {FaChevronDown} from "react-icons/fa";

export function useScrollWithShadow() {
  const [scrollTop, setScrollTop] = useState(0);
  const [scrollHeight, setScrollHeight] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);

  const onScrollHandler = (event) => {
    setScrollTop(event.target.scrollTop);
    setScrollHeight(event.target.scrollHeight);
    setClientHeight(event.target.clientHeight);
  };

  function getBoxShadow() {
    const isBottom = clientHeight === scrollHeight - scrollTop;
    const isTop = scrollTop === 0;
    const isBetween = scrollTop > 0 && clientHeight < scrollHeight - scrollTop;

    let boxShadow = 'none';
    const top = 'inset 0 8px 5px -5px rgb(200 200 200 / 1)';
    const bottom = 'inset 0 -8px 5px -5px rgb(200 200 200 / 1)';

    if (isTop) {
      boxShadow = bottom;
    } else if (isBetween) {
      boxShadow = `${top}, ${bottom}`;
    } else if (isBottom) {
      boxShadow = top;
    }
    return boxShadow;
  }

  const scrollIndicator = useMemo(() => {
    const isBottom = clientHeight === scrollHeight - scrollTop;

    return isBottom ? null : (
      <div className='absolute bottom-2 left-2 right-2 z-[1000] flex items-center justify-center w-full pointer-events-none'>
        <div className='bg-white rounded-full text-brand-text text-sm px-2 py-1 shadow flex gap-2 items-center'>
          <span className='font-bold'>Hover and scroll for more options</span>
          <FaChevronDown className='w-3 h-3'/>
        </div>
      </div>
    )
  }, [clientHeight, scrollTop, scrollHeight])

  return { boxShadow: getBoxShadow(), onScrollHandler, scrollIndicator };
}
